// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x0nK0{position:absolute;top:32px;right:20%;left:20%;height:6px;border-radius:3px;background:#c5d3d6}.Ctl87{position:static;width:200px;margin-right:auto;margin-left:auto}@media screen and (min-width: 768px){.x0nK0{position:static}.esvam{width:300px;margin:-6px auto 30px}.Ctl87{width:188px}}.vgXv_{height:100%;border-radius:3px;background:#22b6e7;-webkit-transition:.2s;transition:.2s}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `x0nK0`,
	"root_inbox": `Ctl87`,
	"root_modal": `esvam`,
	"progress": `vgXv_`
};
module.exports = ___CSS_LOADER_EXPORT___;
